import React from "react";
import { StyledButton } from "../StyledComponents/Buttons/AuradineButtons";
import { LabelLarge } from "../StyledComponents/Typography/Typography.tsx";
import CloseIcon from "@mui/icons-material/Close";
import Close from "@mui/icons-material/Close";
import { StyledIconButton } from "../StyledComponents/Buttons/AuradineButtons";
import { useTheme } from "../../ThemeContext/ThemeContext.js";

const PlaceHolderButton = (props) => {
  const { text, onClose } = props;
  const { colors } = useTheme();
  return (
    <StyledButton colors={colors}>
      <LabelLarge sx={{ color: colors.text.primary }} noWrap> 
        {text}
      </LabelLarge>
      <StyledIconButton size="small" onClick={onClose}>
        <CloseIcon
          sx={{ color: colors.text.primary }}
          fontSize="small"
        />
      </StyledIconButton>
    </StyledButton>
  );
};

export default PlaceHolderButton;
